export interface Page {
    page?: number
    size?: number
    sort?: string[]
    unPaged?: boolean
  }
  
  export class PageBuilder {
    private page?: number | false
    private size?: number
    private sort?: string[]
    // private direction: Object = {}
  
    public setPage(page: number | false): PageBuilder {
      this.page = page
      return this
    }
  
    public setSize(size: number): PageBuilder {
      this.size = size
      return this
    }
  
    public sortedBy(key: string, order?: SortOption): PageBuilder {
      if (!this.sort) {
        this.sort = []
      }
  
      // this.sort = [...this.sort, key]
  
      // if (order) {
      //   this.direction[`${key}.dir`] = order.toString()
      // }
  
      if (!order) {
        this.sort = [...this.sort, key]
      } else {
        this.sort = [...this.sort, `${key},${order.toString()}`]
      }
  
      return this
    }
  
    public build(): Page {
      const page: Page = {}
  
      if (this.page) {
        page.page = this.page
      } else if (this.page === false) {
        page.unPaged = true
      }
  
      if (this.size) {
        page.size = this.size
      }
  
      if (this.sort) {
        page.sort = this.sort
      }
  
      return page
    }
  }
  
  export enum SortOption {
    DESC = "desc",
    ASC = "asc",
  }
  
  export const of = (page: number | false, size?: number) => {
    const builder = new PageBuilder()
  
    if (size) {
      builder.setSize(size)
    }
  
    return builder.setPage(page).build()
  }